import * as z from "zod/v4";

export const autoMergeSpecifiedGroups = {
  name: "autoMergeSpecifiedGroups" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
  }),
  output: z.object({}),
};
